export default __webpack_public_path__ + "img/upload.b8e124c7.svg";